import connector from "@/repository/connector";

export default {
  async login(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/login/", payload),
    );
  },
  async register(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/register/", payload),
    );
  },
  async restorePassword(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/reset-password/request_code/", payload),
    );
  },
  async verify(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/verify/", payload),
    );
  },
  async verifyResetPasswordCode(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/reset-password/verify/", payload),
      undefined,
      { skipUnauthorizedHandler: true },
    );
  },
  async setNewPassword(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/reset-password/new/", payload),
    );
  },
  async refresh(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("auth/refresh/", payload),
      undefined,
      { skipAuthRefresh: true },
    );
  },
  async complete(backend, params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get(`auth/complete/${backend}/`, { params }),
      undefined,
      { skipAuthRefresh: true, skipUnauthorizedHandler: true },
    );
  },
};
